import { useTranslation } from 'react-i18next';

import type { WorkspaceDocument } from '@/entities/document';
import { EmptyState } from '@/shared/ui';

import { DocumentCard } from './DocumentCard';
import styles from './DocumentCatalog.module.css';

/** Notes as a grid of cards; `locations` says where each one is filed (workspace / section / group). */
export function DocumentList({
  documents,
  locations,
  emptyText,
}: {
  documents: readonly WorkspaceDocument[];
  locations?: ReadonlyMap<string, string>;
  emptyText?: string;
}) {
  const { t } = useTranslation();
  if (documents.length === 0) return <EmptyState title={emptyText ?? t('documents.empty')} />;
  return (
    <ul className={styles.grid} data-testid="document-list">
      {documents.map((document) => (
        <DocumentCard
          key={document.id}
          document={document}
          location={locations?.get(document.id)}
        />
      ))}
    </ul>
  );
}
